import { Component, Input, Output, EventEmitter, OnInit } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { ConfigService } from "../../../services/config.service";
import { Methods } from "../../../shared/methods";

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare interface Event {
  evento: "";
  id: null;
  row: null;
}

declare var $: any;

@Component({
  selector: "app-companies-table",
  templateUrl: "./companies-table.component.html",
  styleUrls: ["./companies-table.component.css"],
})
export class CompaniesTableComponent implements OnInit {
  @Input() assigned = false;
  @Input() elements: string[][];
  @Output() out: EventEmitter<Event>;
  public mtds: Methods = new Methods();
  public dataTable: DataTable;
  public options;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _configTable: ConfigService
  ) {
    this.out = new EventEmitter();
  }

  saveEmit(accion, id, row = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      row: row,
    };
    // console.log(send);
    this.out.emit(send);
  }

  ngOnInit() {
    this.dataTable = {
      headerRow: [
        "ID",
        "Company Name",
        "Alias",
        "City",
        "Phone",
        "Status",
        "Actions",
        "CV Code",
        "Date",
      ],
      footerRow: [
        "ID",
        "Company Name",
        "Alias",
        "City",
        "Phone",
        "Status",
        "Actions",
        "CV Code",
        "Date",
      ],
      dataRows: this.elements,
    };
    this._configTable.getConfig("CompanyList").subscribe(
      (r: any) => {
        console.log(r);
        if (r.code === 200) {
          if (r.data) {
            this.options = JSON.parse(r.data.data);
            console.log(this.options);
          } else {
            this.options = this.mtds.colopt(this.dataTable.headerRow, [false]);
          }

          let visibility = [];
          for (let option of this.options) {
            visibility.push({
              targets: [option.origin],
              visible: option.visibility,
            });
          }

          let positions = [];
          while (positions.length < this.options.length) {
            for (let option of this.options) {
              if (option.position === positions.length) {
                positions.push(option.origin);
                break;
              }
            }
          }

          let table = $("#companiestables").DataTable({
            colReorder:
              positions.length !== 0
                ? {
                    order: positions,
                  }
                : true,
            columnDefs: visibility,
            dom: "Bflrtip",
            buttons: [
              {
                extend: "excel",
                text: '<i class="fa fa-file-excel-o"></i>',
                titleAttr: "Excel",
                className: "btn btn-sm btn-outline-success",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "pdf",
                text: '<i class="fa fa-file-pdf-o"></i>',
                titleAttr: "PDF",
                className: "btn btn-sm btn-outline-danger",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "print",
                text: '<i class="fa fa-print" aria-hidden="true"></i>',
                titleAttr: "print",
                className: "btn btn-sm btn-outline-primary",
                exportOptions: {
                  columns: ":visible",
                },
              },
              {
                extend: "colvis",
                text: '<i class="fa fa-columns" aria-hidden="true"></i>',
                className: "btn btn-sm btn-outline-info",
                titleAttr: "Column visibility",
              },
            ],
            pagingType: "full_numbers",
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "All"],
            ],
            responsive: true,
            language: {
              search: "_INPUT_",
              searchPlaceholder: "Search records",
            },
          });

          table.on('click', '.emitir', (e) => {
            console.log(e);
            let res = e.target.id.split("-");
            let row = null;

            for (let item of this.dataTable.dataRows) {
              if (item[0] == res[1]) {
                row = item;
                break;
              }
            }

            this.saveEmit(res[0], res[1], row);
          });

          table.on(
            "column-reorder",
            function (e, settings, details) {
              for (let col of settings.aoColumns) {
                for (let option of this.options) {
                  if (option.origin === col._ColReorder_iOrigCol) {
                    option.position = col.idx;
                    break;
                  }
                }
              }
              this.updateConfig();
            }.bind(this)
          );

          table.on(
            "column-visibility.dt",
            function (e, settings, column, state) {
              for (let option of this.options) {
                if (option.position === column) {
                  option.visibility = state;
                  break;
                }
              }
              this.updateConfig();
            }.bind(this)
          );
        } else {
          this.mtds.notifyError(r.msg);
        }
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
      }
    );

    console.log(this.options);
  }

  updateConfig() {
    this._configTable.setConfig("CompanyList", this.options).subscribe((r) => {
      console.log(r);
    });
  }
}
